import actionCreator from '../../shared/decorators/actionCreator';
import enqueueGAEvent from '../../shared/decorators/enqueueGAEvent';
import { REDUX_NAMESPACE } from '../constants';
import { EVENT_CATEGORY } from '../../analytics/constants';

const ACTION_CREATORS = {
  @actionCreator(REDUX_NAMESPACE)
  downloadCreative(buildParallel, buildPollMax, downloadEpisodeAsSnaps) {
    return {
      buildParallel,
      buildPollMax,
      downloadEpisodeAsSnaps,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  finishDownloadingEpisode() {},

  @actionCreator(REDUX_NAMESPACE)
  finishLoadingPublisherStories() {},

  @actionCreator(REDUX_NAMESPACE)
  finishPublishingEpisode() {},

  @actionCreator(REDUX_NAMESPACE)
  finishUpdatingEdition() {},

  @actionCreator(REDUX_NAMESPACE)
  finishZippingVideo() {},

  @enqueueGAEvent(
    EVENT_CATEGORY.UI.NAME,
    EVENT_CATEGORY.UI.ACTION.REVIEW,
    EVENT_CATEGORY.UI.EVENT_LABEL.REVIEW.REVIEW_MODAL_CLOSED,
  )
  @actionCreator(REDUX_NAMESPACE)
  hideReviewModal() {},

  @actionCreator(REDUX_NAMESPACE)
  loadPublisherStories() {},

  @actionCreator(REDUX_NAMESPACE)
  openEdition() {},

  @enqueueGAEvent(
    EVENT_CATEGORY.UI.NAME,
    EVENT_CATEGORY.UI.ACTION.REVIEW,
    EVENT_CATEGORY.UI.EVENT_LABEL.REVIEW.PUBLISH_TO_ADS_MANAGER_CLICKED,
  )
  @actionCreator(REDUX_NAMESPACE)
  publishToAdsManager() {},

  @enqueueGAEvent(
    EVENT_CATEGORY.UI.NAME,
    EVENT_CATEGORY.UI.ACTION.REVIEW,
    EVENT_CATEGORY.UI.EVENT_LABEL.REVIEW.PUBLISH_CLICKED,
  )
  @actionCreator(REDUX_NAMESPACE)
  publishToStoryStudio(buildParallel, buildPollMax, addToStory) {
    return {
      buildParallel,
      buildPollMax,
      addToStory,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  resetAll() {},

  @actionCreator(REDUX_NAMESPACE)
  setBuiltCreativeVersionId(builtCreativeVersionId) {
    return { builtCreativeVersionId };
  },

  @actionCreator(REDUX_NAMESPACE)
  setEditionForCreative(editionForCreative) {
    return { editionForCreative };
  },

  @actionCreator(REDUX_NAMESPACE)
  setIsDownloadingComplete(isDownloadingComplete) {
    return { isDownloadingComplete };
  },

  @actionCreator(REDUX_NAMESPACE)
  setIsPublishingComplete(isPublishingComplete) {
    return { isPublishingComplete };
  },

  @actionCreator(REDUX_NAMESPACE)
  setPublisherStories(publisherStories) {
    return { publisherStories };
  },

  @actionCreator(REDUX_NAMESPACE)
  setSelectedPublisherStory(selectedPublisherStory) {
    return { selectedPublisherStory };
  },

  @actionCreator(REDUX_NAMESPACE)
  setUpdateEditionProgress(updateEditionProgress) {
    return { updateEditionProgress };
  },

  @actionCreator(REDUX_NAMESPACE)
  setIsUpdateEditionComplete(isUpdateEditionComplete) {
    return { isUpdateEditionComplete };
  },

  @actionCreator(REDUX_NAMESPACE)
  setShowReviewModal({ isShowingReviewModal }) {
    return { isShowingReviewModal };
  },

  @actionCreator(REDUX_NAMESPACE)
  showReviewModal() {},

  @actionCreator(REDUX_NAMESPACE)
  startDownloadingEpisode() {},

  @actionCreator(REDUX_NAMESPACE)
  startPublishingEpisode() {},

  @actionCreator(REDUX_NAMESPACE)
  startLoadingPublisherStories() {},

  @actionCreator(REDUX_NAMESPACE)
  startUpdatingEdition() {},

  @actionCreator(REDUX_NAMESPACE)
  startZippingVideo() {},
};

export default ACTION_CREATORS;
